/**
 * 🔒 P2 보안 개선: 세션 타임아웃 Provider
 *
 * App 전체를 감싸서 세션 타임아웃 기능 제공
 * AuthProvider 내부에서 사용해야 함
 */

import React from 'react';
import { useSessionTimeout } from '../hooks/useSessionTimeout.ts';
import { useAuth } from '../contexts/AuthContext.tsx';
import SessionTimeoutWarning from './SessionTimeoutWarning.tsx';
import { createLogger } from '../utils/logger.ts';

const logger = createLogger('SessionTimeoutProvider');

interface SessionTimeoutProviderProps {
  children: React.ReactNode;
}

const SessionTimeoutProvider: React.FC<SessionTimeoutProviderProps> = ({ children }) => {
  const { user, logout } = useAuth();
  const { isWarningVisible, remainingTime, extendSession } = useSessionTimeout();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      logger.error('Logout error:', error instanceof Error ? error : undefined);
    }
  };

  return (
    <>
      {children}
      {user && (
        <SessionTimeoutWarning
          isVisible={isWarningVisible}
          remainingTime={remainingTime}
          onExtend={extendSession}
          onLogout={handleLogout}
        />
      )}
    </>
  );
};

export default SessionTimeoutProvider;
